import { defineStore } from 'pinia';
import api from '../api';
import { useMainStore } from './index';
import { useWebSocketStore } from '@/stores/websocket';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    unitList: [], // stack unit列表
    unit: '', // 选中的unit
    unitModel: '', // 选中的unit model名称
  }),

  actions: {

    loginPwd(params) {
      return api.login.loginPwd(params)
        .then(data => data)
        .catch(error => { throw error; });
    },
    
    logout() {
      sessionStorage.removeItem('isLogin');
      const wsStore = useWebSocketStore();
      wsStore.disconnectWebSocket();
      return api.login.logout()
        .then(data => {
          return data;
        })
        .catch(error => { throw error; });
    },
    
    changePassword(params) {
      return api.login.changePassword(params)
        .then(data => data)
        .catch(error => { throw error; });
    },
    
    queryHttpPort() {
      return api.common.queryHttpPort()
        .then(data => data)
        .catch(error => { throw error; });
    },
    
    queryTerminal(params) {
      return api.common.queryTerminal(params)
        .then(data => data)
        .catch(error => { throw error; });
    },
    
    queryShureInfo() {
      return api.common.queryShureInfo()
        .then(data => {
          return data;
        })
        .catch(error => { throw error; });
    },
    
    queryStacking() {
      return api.common.queryStacking()
        .then(data => {
          const { resp, stacking } = data;
          if (resp.respCode === 0 && stacking) {
            this.setStacking(stacking)
          }
          return data;
        })
        .catch(error => { throw error; });
    },
    setStacking(stacking){
        const mainStore = useMainStore();

        this.unitList = stacking;
        mainStore.setUnitList(stacking);
        if (!this.unit) {
          const [one] = stacking;
          this.unit = one.unit;
          mainStore.setUnit(one.unit);
          this.unitModel = one.model;
          mainStore.setUnitModel(one.model);
        }
    }
  }
});
